<template>
  <div>
    <span
      v-show="is_in_production"
      v-b-tooltip.hover
      :title="$t('project_in_production')"
      class="fas fa-industry-alt fa-fw text-danger mr-3 p-2"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import * as moment from 'moment'
import 'moment/locale/fr'

import { mapGetters, mapState } from 'vuex'

import { subscription_mixin } from '@/components/mixin.js'
import { set_project_power } from '@/api/subscriptions.js'

// *****************************************************************************

export default {
  name: 'ProjectInProductionIndicator',
  props: ['is_in_production'],
  data() {
    return {
      uid: _.uniqueId(),
    }
  },
}
</script>
